<template>
    <div>
    <div class="air__utils__heading">
      <h5>Facturen</h5>
    </div>
    <div class="row">
      <div class="col-xl-12 col-lg-6">
        <div class="card">
          
          <div class="card-body">
            <a-tabs v-model="tabNumber" defaultActiveKey="1" class="air-tabs-bordered">
              <a-tab-pane tab="Facturen Genereren" key="1" v-if="$auth.check('admin')" />
              <a-tab-pane tab="Factuurlijst" key="2" v-if="$auth.check('admin')" />
              <a-tab-pane tab="Creditlijst" key="3" v-if="$auth.check('admin')" />
            </a-tabs>
            <div v-if="tabNumber == '1'">
              <generation-component />
            </div>
            <div v-if="tabNumber == '2'">
              <list-invoices />
            </div>
            <div v-if="tabNumber == '3'">
              <list-credits />
            </div>
          </div>
        </div>

      </div>
      <div class="col-xl-4 col-lg-6">

      </div>
    </div>
  </div>
</template>
<script>
import GenerationComponent from '@/components/widgets/Invoices/GenerationComponent'
import ListInvoices from '@/components/widgets/Invoices/ListInvoices'
import ListCredits from '../components/widgets/Invoices/ListCredits.vue'
// import moment from 'moment'
export default {
  data(){
    return {
      tabNumber: '1',
    }
  },
  components: {
    GenerationComponent,
    ListInvoices,
    ListCredits
  },
}
</script>
